export default __webpack_public_path__ + "static/media/5-small.b567e4fa.png";